export const currencyFormat = (currency, amount, decimals) => {
    let locale = navigator.language ? navigator.language : 'au-AU';
    return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
    }).format(amount);
}

export const format = (amount) => {
    let locale = navigator.language ? navigator.language : 'au-AU';
    return new Intl.NumberFormat(locale).format(amount)
}

export const unformat = (number) => {
    if (typeof number == 'number') return number;
    return parseFloat(number.replace(/[^0-9.-]+/g, ""));
}